import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box,
} from '@mui/material';
import { teamsAPI } from '../api';

function JoinTeamDialog({ open, onClose, inviterUsername, inviteDigits, preview, onJoinSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const teamName = preview?.teamName || 'this team';

  const handleJoin = async () => {
    if (!inviterUsername || !inviteDigits) return;

    setLoading(true);
    setError(null);
    try {
      const response = await teamsAPI.join(inviterUsername, inviteDigits);
      if (onJoinSuccess) {
        onJoinSuccess(response.data);
      }
      onClose();
      window.location.reload();
    } catch (error) {
      console.error('Failed to join team:', error);
      setError(error.response?.data?.error || 'Failed to join team');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Join Team</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Typography variant="body1">
            You have been invited to join <strong>{teamName}</strong>.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Would you like to join this team? After joining, you will see users from this team (you can be in multiple teams).
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleJoin} variant="contained" disabled={loading}>
          {loading ? 'Joining...' : 'Join Team'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default JoinTeamDialog;
